import React, { Component } from "react";
import { Modal } from "react-bootstrap";
// import { Container, Button, Row, Col } from "react-bootstrap";

export default class PrivacyPolicy extends Component {
  render() {
    const { show, closeModal } = this.props;
    return (
      <React.Fragment>
        <Modal show={show} dialogClassName="banner-modal" onHide={closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Policies</Modal.Title>
          </Modal.Header>
          <Modal.Body className="privacy-policy">
            <h1>Copyright Policy</h1>
            <div>
              Material featured on the "Project Monitoring Group" (PMG) web
              portal may be reproduced free of charge after taking proper
              permission by sending a mail to us. However, the material has to
              be reproduced accurately and not to be used in a derogatory manner
              or in a misleading context. Wherever the material is being
              published or issued to others, the source must be prominently
              acknowledged. However, the permission to reproduce this material
              shall not extend to any material which is identified as being
              copyright of a third party. Authorisation to reproduce such
              material must be obtained from the departments/copyright holders
              concerned.
            </div>
            <h1>Hyperlinking Policy</h1>
            <div>Links to external websites/portals</div>
            <div>
              At many places in the portal, you shall find links to other
              websites/portals. The links have been placed for your convenience.
              PMG is not responsible for the contents and reliability of the
              linked websites and does not necessarily endorse the views
              expressed in them. Mere presence of the link or its listing on
              this portal should not be assumed as endorsement of any kind. We
              cannot guarantee that these links will work all the time and we
              have no control over availability of linked pages.
            </div>
            <div>Links to PMG website by other websites</div>
            <div>
              We do not object to you linking directly to the information that
              is hosted on this site and no prior permission is required for the
              same. However, we would like you to inform us about any links
              provided to this portal so that you can be informed of any changes
              or modifications therein. Also, we do not permit our pages to be
              loaded into frames on your site. The pages belonging to this site
              must load into a newly opened browser window of the User.
            </div>
            <h1>Privacy Policy</h1>
            <div>
              This Privacy Policy is effective as of 1st September, 2019.
            </div>
            <div>
              At Invest India, we recognize the importance of protecting your
              personal information and are committed to processing it
              responsibly and in compliance with applicable data protection laws
              in all countries in which Invest India operates.
            </div>
            <div>
              This privacy statement describes Invest India's general privacy
              practices that apply to personal information we collect, use and
              share about consumers and other individuals within our clients,
              business partners, supplier and other organizations with which
              Invest India has or contemplates a business relationship. Personal
              Data collected are held in order to provide a better service to
              you. We may collect, store and use the following kinds of
              information:
              <ul>
                <li>
                  Information about your computer and about your visits to and
                  use of this website (including your IP address, geographical
                  location, browser type and version, operating system, referral
                  source, length of visit, page views, website navigation)
                </li>
                <li>
                  Information that you provide to us for the purposes of using
                  our website services (including your name, contact details,
                  company name, email, and telephone numbers, a record of our
                  contact with you and your areas of interest e.g. sectors,
                  events, publications, etc.)
                </li>
                <li>Any other information that you choose to send to us.</li>
                <li>
                  Before you disclose to us the personal information of another
                  person, you must obtain that person's consent to both the
                  disclosure and the processing of that personal information in
                  accordance with the terms of this privacy policy.
                </li>
              </ul>
            </div>
            <h1>Using your personal information:</h1>
            <div>We may use your personal information to:</div>
            <ul>
              <li>Administer the website.</li>
              <li>
                Enable your use of the information available on the website
              </li>
              <li>
                Send you email notifications which you have specifically
                requested
              </li>
              <li>
                Send you our communications, publications, newsletter,
                invitations relating to our activities and such like as you may
                select, request or as we may consider being may be of interest
                to you, by post or, where you have specifically agreed to this,
                by email or similar technology (and you can choose to ‘opt-out’
                of these mailings by informing us at any time if you no longer
                require communications)
              </li>
              <li>
                To provide services or information to facilitate companies to
                set up or expand their business operation in India
              </li>
              <li>
                To measure the success of specific campaigns and for general
                market research and for registration for events
              </li>
              <li>
                Provide third parties with overall statistic information about
                our users – but this information will not be used to identify
                any individual user
              </li>
              <li>
                Deal with enquiries and complaints made by or about you relating
                to the website
              </li>
              <li>Keep the website secure and prevent fraud</li>
              <li>
                Verify compliance with the terms governing the use of the
                website.
              </li>
            </ul>
            <h1>How Project Monitoring Group use your data ?</h1>
            <div>
              Applications and services may use your Basic Personal Data in
              below mentioned ways:
            </div>
            <ul>
              <li>To uniquely identify you</li>
              <li>To communicate with you about your Account status</li>
              <li>To authorize your level of access</li>
              <li>
                To reflect your Basic Personal Data to you (for example, an
                on-screen greeting)
              </li>
              <li>
                To perform security/audit logging, including in conjunction with
                your IP Address
              </li>
              <li>
                To perform problem determination, system administration,
                subscription management, usage tracking, and support activities
                and
              </li>
              <li>
                To set secure cookies which maintain your authenticated user
                session(s) with applications or services.
              </li>
            </ul>
            <div>Security and Retention of Personal Data:</div>
            <ul>
              <li>
                We will take reasonable technical and organisational precautions
                to prevent the loss, misuse or alteration of your personal
                information.
              </li>
              <li>
                We will store all the personal information you provide on our
                secure (password and firewall-protected) servers.
              </li>
              <li>
                Only authorised people have access to, custody of and the means
                of using personal data PMG collects.
              </li>
              <li>
                Invest India retains personal data so long as the data are still
                required for the purposes mentioned above.
              </li>
              <li>
                You acknowledge that the transmission of information over the
                internet is not inherently secure, and we cannot guarantee the
                security of data sent over the internet.
              </li>
              <li>
                Invest India promotes a privacy-aware culture that respects and
                is sensitive to the rights of its external contacts.
              </li>
            </ul>
            <div>Retention period</div>
            <div>
              We will not retain personal information longer than necessary to
              fulfil the purposes for which it is processed, including the
              security of our processing complying with legal and regulatory
              obligations (e.g. audit, accounting and statutory retention
              terms), handling disputes, and for the establishment, exercise or
              defence of legal claims in the countries where Invest India
              operates. The retention period for storage of the user data would
              be 3 years from the closure/discontinuance of the
              website/services.
            </div>
            <h1>Cookies:</h1>
            <div>
              We use only "session" cookies on the website. Session cookies will
              be deleted from your computer when you close your browser. We will
              use the session cookies to keep track of you whilst you navigate
              the website. Most browsers allow you to reject all cookies, whilst
              some browsers allow you to reject just third party cookies. Please
              note that blocking all cookies may have a negative impact on the
              usability of many websites, including this one.
            </div>
            <h1>Disclosures:</h1>
            <div>
              We may disclose your personal information to any of our employees,
              officers or agents, insofar as reasonably necessary for the
              purposes set out in this privacy policy.
            </div>
            <div>In addition, we may disclose your personal information:</div>
            <ul>
              <li>To the extent that we are required to do so by law</li>
              <li>
                In connection with any on-going or prospective legal proceedings
              </li>
              <li>
                In order to establish, exercise or defend our legal rights
              </li>
            </ul>
            <div>
              To any person who we reasonably believe may apply to a court or
              other competent authority for disclosure of that personal
              information where, in our reasonable opinion, such court or
              authority would be reasonably likely to order disclosure of that
              personal information. All disputes are subject to the jurisdiction
              of the Delhi (India) Courts.
            </div>
            <h1>Your rights:</h1>
            <div>
              You may instruct us to provide you with any personal information
              we hold of you. Please note that provision of such information
              will be subject to the supply of appropriate evidence (as deemed
              by Invest India) of your identity.
            </div>
            <div>
              You can request to access, update or correct your personal
              information. You also have the right to object to direct
              marketing.
            </div>
            <h1>Right to lodge a complaint</h1>
            <div>
              In the event you consider our processing of your personal
              information not to be compliant with the applicable data
              protection laws, you can lodge a complaint by choosing any of the
              two options mentioned below-
            </div>
            <ul>
              <li>Directly with PMG by using the contact-us link</li>
            </ul>
            <h1>Third party websites:</h1>
            <div>
              The website contains links to other websites. We are not
              responsible or accountable for the privacy policies or practices
              of third-party websites.
            </div>
            <div>
              All disputes are subject to the jurisdiction of the Delhi (India)
              courts.
            </div>
            <h1>Information security and accuracy</h1>
            <div>
              We intend to protect your personal information and to maintain its
              accuracy. PMG platform has reasonable physical, administrative and
              technical safeguards to help us protect your personal information
              from unauthorized access, use and disclosure. For example, we
              encrypt certain sensitive personal information when we transmit
              such information over the internet. We also require that our
              suppliers protect such information from unauthorized access, use
              and disclosure.
            </div>
            <h1>Updating information/ contacting us:</h1>
            <div>
              If you have a question related to this Privacy Statement, please
              use the contact-us link. Your message will be forwarded to the
              appropriate member of Invest India's Data Privacy Team, such as
              Data Protection Officers or members of their teams.
            </div>
            <div>
              For the purposes of the EU General Data Protection Regulation
              (GDPR), the controller of your personal information is "Invest
              India, Vigyan Bhavan Annexe, Maulana Azad Road, New Delhi 110001
              ". If the personal information that we hold about you needs to be
              corrected or updated or if you have any questions about this
              privacy policy or our treatment of your personal information,
              please contact us through using the contact-us.
            </div>
            <h1>Changes to our privacy statements</h1>
            <div>
              From time to time we may update this Privacy Statement, as well as
              any other specific privacy statement. When making changes to this
              Privacy Statement, we will add a new date at the top of this
              Privacy Statement.
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
